import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NotFoundComponent } from '@appCore/components/not-found/not-found.component';
import { NotServiceAvailableComponent } from '@appCore/components/not-service-available/not-service-available.component';
import { AuthGuard } from '@appCore/guards/auth/auth.guard';
import { MainLayoutComponent } from '@appCore/layouts/main-layout.component';
import { RouteEnum } from '@appCore/models';
import { DocumentViewerComponent } from '@appShared/components/document-viewer/document-viewer.component';

export const isAuthenticated = (guard = inject(AuthGuard)) => guard.canActivate();

const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        loadChildren: () => import('../app/pages/login/login.module').then((m) => m.LoginModule)
    },

    {
        path: 'home',
        component: MainLayoutComponent,
        canActivate: [() => isAuthenticated()],
        loadChildren: () => import('../app/pages/home/home.module').then((m) => m.HomeModule)
    },
    {
        path: 'area-marketing',
        component: MainLayoutComponent,
        canActivate: [() => isAuthenticated()],
        loadChildren: () => import('../app/pages/marketing-area/marketing-area.module').then((m) => m.MarketingAreaModule)
    },
    {
        path: 'clientes',
        component: MainLayoutComponent,
        canActivate: [() => isAuthenticated()],
        loadChildren: () => import('../app/pages/customers/customers.module').then((m) => m.CustomersModule)
    },
    {
        path: 'sucursales',
        component: MainLayoutComponent,
        canActivate: [() => isAuthenticated()],
        loadChildren: () => import('../app/pages/offices/offices.module').then((m) => m.OfficesModule)
    },
    {
        path: 'consultas',
        component: MainLayoutComponent,
        canActivate: [() => isAuthenticated()],
        loadChildren: () => import('../app/pages/consultations/consultations.module').then((m) => m.ConsultationsModule)
    },
    {
        path: RouteEnum.Reports,
        component: MainLayoutComponent,
        canActivate: [() => isAuthenticated()],
        loadChildren: () => import('./pages/reports/reports.module').then((m) => m.ReportsModule)
    },
    {
        path: 'documentacion-general',
        component: MainLayoutComponent,
        canActivate: [() => isAuthenticated()],
        loadChildren: () => import('../app/pages/general-documentation/general-documentation.module').then((m) => m.GeneralDocumentationModule)
    },
    {
        path: 'procedimientos',
        component: MainLayoutComponent,
        canActivate: [() => isAuthenticated()],
        loadChildren: () => import('../app/pages/procedures/procedures.module').then((m) => m.ProceduresModule)
    },
    {
        path: 'document-viewer',
        component: DocumentViewerComponent
    },
    {
        path: 'not-service-available',
        component: NotServiceAvailableComponent
    },
    {
        path: '**',
        component: NotFoundComponent
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            onSameUrlNavigation: 'ignore',
            anchorScrolling: 'enabled',
            scrollPositionRestoration: 'enabled',
            useHash: true
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
